import type { HelpFile } from '../../types/help'
import { TypeScopeSelectorTestIds } from '../../../testids/TypeScopeSelectorTestIds'

export const typeScopeSelectorHelp: HelpFile = {
  docPage: '/docs/schema/attribute-definitions',
  texts: {
    [TypeScopeSelectorTestIds.typeScopeAll]: 'Apply this attribute or rule to every type. No further selection is needed.',
    [TypeScopeSelectorTestIds.typeScopeSpecific]: 'Restrict this attribute or rule to the specific types selected below.',
    [TypeScopeSelectorTestIds.typeScopeAdd]: 'Add another type to the scope.',
  },
}
